import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { Downtime } from '../times/downtime';

@Injectable({
  providedIn: 'root'
})
export class ExitService {
  auth = inject(AuthService);
  router = inject(Router);
  downtime = inject(Downtime);


  exitSystem(){
    this.auth.logout();
    this.closeSystem();
  }

  closeSystem(){
    this.auth.exitCompletion();
    sessionStorage.clear();
    this.downtime.ngOnDestroy();
    this.router.navigate(['/']);
  }
  
}
